import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=557d3899&"
import script from "./NavButton.vue?vue&type=script&lang=js&"
export * from "./NavButton.vue?vue&type=script&lang=js&"
import style0 from "./NavButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/npm-packages/global-vue-components-commit/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557d3899')) {
      api.createRecord('557d3899', component.options)
    } else {
      api.reload('557d3899', component.options)
    }
    module.hot.accept("./NavButton.vue?vue&type=template&id=557d3899&", function () {
      api.rerender('557d3899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/NavButton.vue"
export default component.exports